<template>
  <div
    class="drawer animated"
    :class="
      direction === 'right' ? 'rightSide fadeInRight' : 'leftSide fadeInLeft'
    "
    :style="{
      width: width,
    }"
  >
      <!-- background: pageComponent == 'szhjPage' ? 'rgba(15,20,24,.9)' : '' -->
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["pageComponent"])
  },
  props: {
    width: {
      type: String,
      default: "450px"
    },
    direction: {
      type: String,
      default: "right"
    }
  },
  mounted() {
    // setTimeout(() => {
    //   document.getElementsByClassName("fadeInLeft")[0].style.animation =
    //     "loadAni_left .5s linear forwards";
    //   document.getElementsByClassName("fadeInRight")[0].style.animation =
    //     "loadAni_right .5s linear forwards";
    // }, 1);
  }
};
</script>

<style lang="stylus" scoped>
.drawer
  position absolute
  top 90px
  bottom 50px
  z-index 9
  padding 10px
  box-sizing border-box
  // animation-delay: 0s;
  // opacity 0

.rightSide
  right 15px

.leftSide
  left 15px
</style>



// WEBPACK FOOTER //
// src/components/vDrawer.vue